import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/contact/ContactForm.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/CopyText/CopyTextClient.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/components/MaskText/MaskTextClient.tsx")